import type { TimestampedEntry } from '@/modules/viewer/types/logs';

// Re-export UI type shorthands so components that pull utilities from here
// don't also need a separate import from types/logs.
export type { ConsoleFilter, NetworkFilter, LogSubTab, LogsLoadStatus } from '@/modules/viewer/types/logs';

/**
 * Compute the id of the nearest-past entry for a given currentTime.
 * Used for the auto-scroll highlight. Entries must be sorted by timestamp asc.
 */
export const findActiveEntryId = (entries: TimestampedEntry[], currentTime: number): string | null => {
  let activeId: string | null = null;
  for (const entry of entries) {
    if (entry.timestamp <= currentTime) {
      activeId = entry.id;
    } else {
      break;
    }
  }
  return activeId;
};

/**
 * Format seconds as MM:SS or HH:MM:SS for log timestamps.
 */
export const formatLogTimestamp = (seconds: number): string => {
  const total = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  if (hours > 0) {
    return `${hours}:${pad(minutes)}:${pad(secs)}`;
  }
  return `${pad(minutes)}:${pad(secs)}`;
};
